import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "../../Common/Input/Input";
import classes from "./QuizImage.module.scss";

const QuizImage = ({
  image,
  name = "",
  value,
  handleClick,
  handleChange = () => {},
  fieldValue,
  selectType = "checkbox",
  isImagesCheckbox,
  ...rest
}) => {
  const { setValue } = useFormContext({});
  // console.log(value, image)
  return (
    <div
      className={classes.quizImage}
      onClick={(e) => {
        e.stopPropagation();
        if (selectType === "radio") {
          setValue(name, image);
          handleChange();
        }
        if (handleClick) {
          // debugger;
          handleClick(image[fieldValue]);
          if (isImagesCheckbox) {
            // setValue(QuestionImageList, image);
            // setValue(name + rest?.index, "");
            // console.log(image,name)
            // setValue(name, image);
            handleChange(image);
          }
        }
      }}
    >
      <img
        src={image.MediaUri}
        alt={image.FileName}
        className={classes.quizImage__image}
      />
      <div className={classes.quizImage__checkBox}>
        {selectType === "checkbox" ? (
          <Input
            name={name + rest?.index}
            type={"checkbox"}
            checked={value}
            // onChange={() => handleClick(id)}
            height="2"
            width="2"
            direction="row-reverse"
            onChange={() => {
              // setValue(name, image);
              handleChange(image);
            }}
          />
        ) : selectType === "radio" ? (
          <Input
            name={name + rest?.index}
            type="radio"
            height="2"
            width="2"
            value={image}
            direction="row-reverse"
            onChange={() => {
              setValue(name, image);
              setValue(name + rest?.index, "");
              handleChange();
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default QuizImage;
